import React from 'react';

import classNames from 'classnames';
import styled from 'styled-components';

import { COMPANY_COMMUNITY_RELATION_TYPE } from 'constants/company';

import CommunityViewHeaderBreadcrumbs from './CommunityViewHeaderBreadcrumbs';
import HeaderViewActions from '../actions/HeaderViewActions';
import { useCommunityViewContext } from '../CommunityViewContext';
import HeaderViewFilters from '../filters/HeaderViewFilters';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  background: white;
  border-bottom: 1px solid var(--line-gray);

  &.no-border {
    border-bottom: none;
  }
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px 20px 10px 30px;
`;

const HeaderContent = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

const Info = styled.div`
  display: flex;
  flex-direction: column;
`;

const Title = styled.span`
  font-family: var(--font-bold);
  font-size: 40px;
  padding: 3px 0px;
`;

const CommunityViewHeader = () => {
  const { community, competitors, competitorId, isViewSalesBattlecard, view } = useCommunityViewContext();

  const communityToDisplay = competitors?.find((c) => c.id === competitorId) || community;
  const communityForBreadcrumbs = competitorId
    ? { ...communityToDisplay, type: COMPANY_COMMUNITY_RELATION_TYPE.COMPETITOR }
    : communityToDisplay;
  const communityName = communityToDisplay?.comunity_name;

  return (
    <Container className={classNames({ 'no-border': isViewSalesBattlecard })}>
      <Content>
        <HeaderContent>
          <Info>
            <CommunityViewHeaderBreadcrumbs community={communityForBreadcrumbs} />
            <Title>{isViewSalesBattlecard ? view?.name : communityName}</Title>
          </Info>
          <HeaderViewActions />
        </HeaderContent>
        <HeaderViewFilters />
      </Content>
    </Container>
  );
};

export default CommunityViewHeader;
